import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  userId: null,
  userName: null,
  userRole: null,
  userEnstituId: null,
  userEnstituName: null
}

export const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      state.userId = action.payload.userId
      state.userName = action.payload.userName
      state.userRole = action.payload.userRole
      state.userEnstituId = action.payload.userEnstituId
      state.userEnstituName = action.payload.userEnstituName
    },
    logout: (state) => {
      state.userId = null
      state.userName = null
      state.userRole = null
      state.userEnstituId = null
      state.userEnstituName = null
    },
  },
})

// Action creators are generated for each case reducer function
export const { login, logout } = auth.actions

export default auth.reducer